export default __webpack_public_path__ + "static/media/local_silk_flower.18846ae0.png";